export default "__VITE_ASSET__zn56s7tc__"